import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CrudApi from "@serie3/common/api/crudApi";
import {
  faTrash,
  faFilePdf, faFileImage, faFileWord, faFileExcel, faFile,
} from "@fortawesome/free-solid-svg-icons";

const extIcon = (name = "") => {
  const ext = name.split(".").pop().toLowerCase();
  if (ext === "pdf") return { icon: faFilePdf, color: "#c62828", bg: "#ffebee" };
  if (["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(ext))
    return { icon: faFileImage, color: "#1565c0", bg: "#e3f2fd" };
  if (["doc", "docx"].includes(ext))
    return { icon: faFileWord, color: "#1a73e8", bg: "#e8f0fe" };
  if (["xls", "xlsx"].includes(ext))
    return { icon: faFileExcel, color: "#2e7d32", bg: "#e8f5e9" };
  return { icon: faFile, color: "#757575", bg: "#f5f5f5" };
};

const ConnectedFiles = ({ entity, show, endpointAll, endpointUnlink, onFileSelect, selectedFileId }) => {
  const [attachments, setAttachments] = useState([]);

  useEffect(() => {
    if (show === false) return;
    CrudApi.getAll(endpointAll + entity.id).then((r) => setAttachments(r.data));
  }, [show]);

  const handleUnlink = async (attachmentId) => {
    try {
      const response = await CrudApi.del(endpointUnlink, attachmentId);
      if (response.status === 200) {
        setAttachments((prev) => prev.filter((a) => a.id !== attachmentId));
        if (selectedFileId === attachmentId && onFileSelect) onFileSelect(null);
      }
    } catch (e) {}
  };

  if (attachments.length === 0) return null;

  return (
    <div style={{
      display: "flex", flexWrap: "wrap", gap: "8px",
      padding: "12px", background: "#f8f9fa", borderRadius: "10px", marginTop: "8px",
    }}>
      {attachments.map((attachment) => {
        const { icon, color, bg } = extIcon(attachment.originalName);
        const active = selectedFileId === attachment.id;
        return (
          <div
            key={attachment.id}
            onClick={() => onFileSelect && onFileSelect(active ? null : attachment)}
            style={{
              display: "inline-flex", alignItems: "center", gap: "10px",
              background: active ? "#e8f0fe" : "#fff",
              border: `1px solid ${active ? "#1a73e8" : "#e0e0e0"}`,
              borderRadius: "10px", padding: "10px 14px",
              boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
              cursor: onFileSelect ? "pointer" : "default",
            }}
          >
            <div style={{
              width: "42px", height: "42px", borderRadius: "8px",
              background: bg, display: "flex", alignItems: "center",
              justifyContent: "center", flexShrink: 0,
            }}>
              <FontAwesomeIcon icon={icon} style={{ color, fontSize: "1.2rem" }} />
            </div>

            <span
              style={{
                fontSize: "0.92rem", fontWeight: 500,
                color: active ? "#1a73e8" : "#424242",
                maxWidth: "180px", overflow: "hidden",
                textOverflow: "ellipsis", whiteSpace: "nowrap",
              }}
              title={attachment.originalName}
            >
              {attachment.originalName}
            </span>

            <button
              onClick={(e) => { e.stopPropagation(); handleUnlink(attachment.id); }}
              title="Remove"
              style={{
                background: "none", border: "none", cursor: "pointer",
                color: "#e53935", padding: "6px 8px",
                display: "flex", alignItems: "center",
                fontSize: "1rem", lineHeight: 1,
              }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default ConnectedFiles;
